export class CostReviewProvenOutcomesProactiveServicesSa {
    minimumThreeRequiredTools: string = '';
    automationHealthReport: string = '';
    capPlus: string = '';
    onlineDataBackupService: string = '';
    systemPerformanceMonitoring: string = '';
    bacnetNetworkAnalysis: string = '';
    dataFoxProactive: number = 0;
    zoneRxProActive: number = 0;
    performanceReportingTool: string = '';
    cloudFims: string = '';
    cloudOps: string = '';
    hvacOperationalAnalytics: string = '';
    fddCustom: number = 0;
    kpisDiscussed: number = 0;
    standardDsc: number[] = [];
    nonStandardKpiIncluded: number = 0;
    nonStandardKpiSubmitted: number = 0;
    reasonOptOut: string = '';
    automationPMIncludedNew: string = '';
    advancedProactvieServicesNew: string = '';
    smOrBgmApprovalRequired: number = 0;
    tisHealth: string = '';
    tisBuildingMgmtSystemHealth: string = '';
    tisNetworkHealth: string = '';
    tisMechEquipmentHealth: string = '';
    reasonForException: string = '';
    approverEmailId: string = '';
}